/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { PutUsersPreferencesWaterCharacteristicsOptions, PutUsersPreferencesWaterCharacteristicsResponses } from '../types/PutUsersPreferencesWaterCharacteristics'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /users/preferences/water-characteristics/}
 */
export function putUsersPreferencesWaterCharacteristics<ThrowOnError extends boolean = true>(options: Options<PutUsersPreferencesWaterCharacteristicsOptions, ThrowOnError>): Unwrappable<RequestResult<PutUsersPreferencesWaterCharacteristicsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'PUT', url: '/users/preferences/water-characteristics/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<PutUsersPreferencesWaterCharacteristicsResponses, ThrowOnError>>)
}
